import apiClient from '../base/apiClient';

export const userAddressApi = {
  getUserAddresses: async (params: { userId: number }) => {
    const { userId } = params;
    const response = await apiClient.get('/Administration/Address/UserListAll', { params: { userId } });
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    const addresses = response.data.addresses || [];
    return {
      data: addresses.map((address: any) => ({
        addressId: address.addressId,
        isPrimary: address.isPrimary || false,
        addresseeFirstName: address.addresseeFirstName || '',
        addresseeMiddleName: address.addresseeMiddleName || '',
        addresseeLastName: address.addresseeLastName || '',
        coordinatesLatitude: address.coordinatesLatitude || 0,
        coordinatesLongitude: address.coordinatesLongitude || 0,
        unit: address.unit || '',
        building: address.building || '',
        street: address.street || '',
        subdivision: address.subdivision || '',
        city: {
          cityId: address.city.cityId,
          provinceId: address.city.provinceId,
          province: {
            provinceId: address.city.province.provinceId,
            name: address.city.province.name,
          },
          name: address.city.name,
          class: address.city.class,
        },
        province: {
          provinceId: address.province.provinceId,
          name: address.province.name,
        },
        zipCode: address.zipCode || '',
      })),
      total: response.data.total || addresses.length,
    };
  },

  createUserAddress: async (params: { data: any }) => {
    const { data } = params;
    const response = await apiClient.post('/Administration/Address/UserCreate', data, {
      headers: { 'Content-Type': 'application/json' },
    });
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    return { data: { addressId: response.data.addressId || 0, ...data } };
  },

  deleteUserAddress: async (params: { userId: number; addressId: number }) => {
    const { userId, addressId } = params;
    const response = await apiClient.get('/Administration/Address/UserDelete', { params: { userId, addressId } });
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    return { data: { userId, addressId } };
  },

  getAllCitiesUser: async (params: { count?: number; page?: number }) => {
    const { count = 100, page = 0 } = params;
    const response = await apiClient.get('/Administration/Address/ListAllCities', { params: { count, page } });
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    return { data: response.data.cities };
  },

  lookupCitiesUser: async (params: { name: string; count?: number; page?: number }) => {
    const { name, count = 100, page = 0 } = params;
    const response = await apiClient.get('/Administration/Address/LookupCities', { params: { name, count, page } });
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    return { data: response.data.cities || [] };
  },

  updateUserAddress: async (params: { userId: number; addressId: number; data: any }) => {
    const { userId, addressId, data } = params;
    const response = await apiClient.post('/Administration/Address/UserUpdate', data, {
      params: { userId, addressId },
      headers: { 'Content-Type': 'application/json' },
    });
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    return { data: { addressId, ...data } };
  },

  userSetPrimary: async (params: { userId: number; addressId: number }) => {
    const { userId, addressId } = params;
    const response = await apiClient.get('/Administration/Address/UserSetPrimary', { params: { userId, addressId } });
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    return { data: { success: true } };
  },

  userTotalCount: async (params: { filter?: string; count?: number } = {}) => {
    const { filter = '', count = 100 } = params;
    const response = await apiClient.get('/Administration/Account/UserCount', { params: { filter, count } });
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    return { data: { count: response.data.count || 0, pages: response.data.pages || 0 } };
  },

  getUserDocuments: async (params: { userId: number }) => {
    const { userId } = params;
    const response = await apiClient.get('/Administration/Account/ListDocuments', { params: { userId } });
    if (response.data.errorMessage) throw new Error(response.data.errorMessage);
    if (response.data.error) throw new Error(response.data.error);
    const documents = response.data.documents || [];
    return {
      data: documents.map((doc: any) => ({
        userId,
        documentId: doc.documentId,
        filename: doc.filename ? `${apiClient.defaults.baseURL}${doc.filename}` : '',
        mimeType: doc.mimeType || '',
        status: doc.status || '',
        type: doc.type || '',
        notes: doc.notes || null,
      })),
      total: documents.length,
    };
  },
};